import React from "react";
import {
  Card, CardBody, Container, CardHeader,
  InputGroup, FormGroup, InputGroupText, Input, Form
} from "reactstrap";
import { Link } from "react-router";
import SimpleHeader from "@/components/Headers/SimpleHeader";
import UsersListContainer from "./DisplayUsers/UsersListContainer";
import type {
  ListedUser,
  UsersListContainerProps,
} from "./DisplayUsers/UsersListContainer";

export type UsersViewProps = {
  total: number;
  users: ListedUser[];
  permission?: UsersListContainerProps["permission"];
  onSearch: (value: string) => void;
  onLocalDelete?: UsersListContainerProps["cleaningDeletedUserState"];
  onLocalEditRole?: UsersListContainerProps["updateRoleHandler"];
};

const UsersView = ({
  total,
  users,
  permission,
  onSearch,
  onLocalDelete,
  onLocalEditRole,
}: UsersViewProps) => (
  <>
    <SimpleHeader name="Users List" parentName="Users" />
    <Container className="mt--6" fluid>
      <Card>
        <CardHeader className="text-center">
          <h3 className="mb-0">Users List {" (" + total + ") "}</h3>

          <Form className="navbar-search form-inline mr-sm-3 navbar-search-dark float-left">
            <FormGroup className="mb-0">
              <InputGroup className="input-group-alternative input-group-merge">
                <InputGroupText>
                  <i className="fas fa-search" />
                </InputGroupText>
                <Input
                  placeholder="Search by user name"
                  type="text"
                  onChange={(e) => onSearch(e.target.value)}
                />
              </InputGroup>
            </FormGroup>
          </Form>

          { (permission?.edit || permission?.publish) ? (
            <Link
              to="/admin/add-user"
              className="btn btn-outline-primary mr-1 float-right"
            >
              Add New User
            </Link>
          ) : null}
        </CardHeader>

        <CardBody>
          <UsersListContainer
            users={users}
            cleaningDeletedUserState={onLocalDelete}
            updateRoleHandler={onLocalEditRole}
            permission={permission}
          />
        </CardBody>
      </Card>
    </Container>
  </>
);

export default UsersView;
